var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { O as OwnedSchema } from "../../Owned-84ee52ae.js";
import { registerSystem } from "../ComponentRegistry.js";
import { O as OwnerSchema } from "../../Owner-4cb1d33a.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../enums-86f58524.js";
import "../../global-33d5eebf.js";
import "../types.js";
import "../../utils/byteArray.js";
class OwnerSystem {
  constructor() {
    __publicField(this, "schema", OwnerSchema);
    __publicField(this, "type", "Owner");
  }
  init(entity, gameModel) {
    const owner = gameModel.getTypedUnsafe(entity, OwnerSchema).owner;
    if (owner === null)
      return;
    if (!gameModel.isActive(owner)) {
      gameModel.getTypedUnsafe(entity, OwnerSchema).owner = null;
      return;
    }
    if (!gameModel.hasComponent(owner, "Owned")) {
      gameModel.addComponent(owner, "Owned", { owned: [entity] });
    } else {
      const owned = gameModel.getTypedUnsafe(owner, OwnedSchema);
      if (!owned.owned.includes(entity)) {
        owned.owned.push(entity);
      }
    }
  }
  cleanup(entity, gameModel, ejecting) {
    if (ejecting)
      return;
    const owner = gameModel.getTypedUnsafe(entity, OwnerSchema).owner;
    if (owner === null)
      return;
    if (!gameModel.isActive(owner))
      return;
    if (!gameModel.hasComponent(owner, "Owned")) {
      return;
    }
    const owned = gameModel.getTypedUnsafe(owner, OwnedSchema);
    owned.owned = owned.owned.filter((ownedEntity) => {
      if (ownedEntity === entity)
        return false;
      if (!gameModel.isActive(ownedEntity))
        return false;
      return true;
    });
  }
}
registerSystem(OwnerSystem);
//# sourceMappingURL=Owner.js.map
